import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Subscriber } from 'rxjs/Subscriber';
import { Subscription } from 'rxjs/Subscription';

export class ProgressBarEventArgs {
    targetId: string;
    isVisible : boolean;
}

export class ProgressBarEvent {
    constructor(public value: any) { }
}

/**
 * SlimLoadingBar service helps manage Slim Loading bar on the top of screen or parent component
 */
@Injectable()
export class ProgressBarService {

    private _progress: number = 0;
    private _height: string = '2px';
    private _color: string = 'firebrick';
    private _visible: boolean = true;

    private _intervalCounterId: any = 0;
    public interval: number = 500; // in milliseconds

    public observable: Observable<ProgressBarEvent>;
    private subscriber: Subscriber<ProgressBarEvent>;

    constructor() {
        this.observable = new Observable<ProgressBarEvent>((subscriber: Subscriber<ProgressBarEvent>) => {
            this.subscriber = subscriber;
        });
    }

    set progress(value: number) {
        if (isPresent(value)) {
            if (value > 0) {
                this.visible = true;
            }
            this._progress = value;
            this.emitEvent(new ProgressBarEvent(this._progress));
        }
    }

    set visible(value: boolean) {
        if (isPresent(value)) {
            this._visible = value;
            this.emitEvent(new ProgressBarEvent(this._progress));
        }
    }

    get progress(): number {
        return this._progress;
    }

    private emitEvent(event: ProgressBarEvent) {
        if (this.subscriber) {
            // Push up a new event
            this.subscriber.next(event);
        }
    }


    start(onCompleted: Function = null) {
        // Stop current timer
        this.stop();
        // Make it visible for sure
        this.visible = true;
        // Run the timer with milliseconds iterval
        this._intervalCounterId = setInterval(() => {
            // Increment the progress and update view component
            this.progress++;
            // If the progress is 100% - call complete
            if (this.progress === 100) {
                this.complete();
            }
        }, this.interval);
    }

    stop() {
        if (this._intervalCounterId) {
            clearInterval(this._intervalCounterId);
            this._intervalCounterId = null;
        }
    }

    reset() {
        this.stop();
        this.progress = 0;
    }

    complete() {
        this.progress = 100;
        this.stop();
        setTimeout(() => {
            // Hide it away
            this.visible = false;
            setTimeout(() => {
                // Drop to 0
                this.progress = 0;
            }, 250);
        }, 250);
    }


}

export function isPresent(obj: any) {
    return obj !== undefined && obj !== null;
}


/** WEBPACK FOOTER **
 ** ./app/services/progressbar.service.ts
 **/